import { SxProps, Theme } from '@mui/material';
import { MSG_BACK, MSG_NEXT, MSG_RESET, MSG_SUBMIT } from 'common/messages';

interface IData {
  text: string;
  type: 'submit' | 'reset' | 'button';
  style?: SxProps<Theme>;
}

export const getButtonData = (name: string, isDisabled?: boolean): IData => {
  const observerName: { [key: string]: () => IData } = {
    submit: () => ({
      type: 'submit',
      text: MSG_SUBMIT.toUpperCase(),
      style: {
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: 'bold',
        lineHeight: '24px',
        letterSpacing: '0.4px',
        textAlign: 'left',
        color: '#FFFFFF',
        background: isDisabled ? '#B0BEC5' : '#0048B6',
        '&:hover': { backgroundColor: '#0048b6ba' },
      },
    }),
    reset: () => ({ type: 'reset', text: MSG_RESET.toUpperCase() }),
    button: () => ({ type: 'button', text: 'BUTTON' }),
    next: () => ({
      type: 'button',
      text: MSG_NEXT.toUpperCase(),
      style: {
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: 'bold',
        lineHeight: '24px',
        letterSpacing: '0.4px',
        textAlign: 'left',
        color: '#FFFFFF',
        background: isDisabled ? '#B0BEC5' : '#0048B6',
        '&:hover': { backgroundColor: '#0048b6ba' },
      },
    }),
    back: () => ({
      type: 'button',
      text: MSG_BACK.toUpperCase(),
      style: {
        fontFamily: 'Roboto',
        fontSize: '14px',
        fontWeight: 'bold',
        lineHeight: '24px',
        letterSpacing: '0.4px',
        textAlign: 'left',
        color: '#0048B6',
        marginRight: '20px',
      },
    }),
  };

  return observerName[name] ? observerName[name]() : observerName.button();
};
